import { styled } from "goober";
import { useEffect, useRef, useState } from "react";
import { NEW_USER_INTRO_VIDEO_FEATURE_FLAG } from "../../shared/featureFlagNames";
// TODO - replace with the real video when it's ready
import introVideo from "../assets/video/new-user-intro-placeholder.mp4";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import { trackVideoEvent } from "../lib/tracing";
import { Modal } from "./Modal";

const SIGNUP_FLOW_STORAGE_KEY = "3b-new-user-from-signup-flow";
const VIDEO_NAME = "new-user-intro";

function cameFromSignupFlow(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(SIGNUP_FLOW_STORAGE_KEY) !== null;
}

const VideoFrame = styled("div")`
  width: min(80vw, 800px);
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 16px;
  background: var(--surface-secondary);

  & video {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export function NewUserIntroVideo() {
  const flagEnabled = useFeatureFlag(NEW_USER_INTRO_VIDEO_FEATURE_FLAG);
  const [eligible] = useState(cameFromSignupFlow);
  const [open, setOpen] = useState(false);
  const hasShown = useRef(false);

  useEffect(() => {
    if (hasShown.current || !flagEnabled || !eligible) return;
    hasShown.current = true;
    localStorage.removeItem(SIGNUP_FLOW_STORAGE_KEY);
    setOpen(true);
  }, [flagEnabled, eligible]);

  if (!open) return null;

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <VideoFrame>
        <video
          src={introVideo}
          controls
          playsInline
          preload="metadata"
          onPlay={() => trackVideoEvent(VIDEO_NAME, "play")}
          onPause={() => trackVideoEvent(VIDEO_NAME, "pause")}
          onEnded={() => trackVideoEvent(VIDEO_NAME, "ended")}
        />
      </VideoFrame>
    </Modal>
  );
}
